import { buildNavigationType } from "../shared/buildNavigationType";
import { buildPageObject } from "../shared/buildPageObject";
import { EventAction, EventName } from "../types";

import type { PageLeaveEvent, PageLeaveInput } from "./types";

type EventBuilder = (input?: PageLeaveInput) => PageLeaveEvent;

const pageLeaveEventBuilder: EventBuilder = (input) => {
  const { customProperties, currentPath } = input || {};

  const timestamp = new Date(Date.now() - 2).toISOString();

  const pageObject = buildPageObject(currentPath);
  const navigationType = buildNavigationType();

  return {
    name: EventName.PageLeave,
    action: EventAction.Leave,
    target: pageObject,
    navigationType,
    timestamp,
    customProperties,
  };
};

export { pageLeaveEventBuilder };
